  document.addEventListener('DOMContentLoaded', function() {
    function updateInventoryStatus(variant) {
      const quantitySelector = document.querySelector('[data-quantity-selector]');
      const soldOutMessage = document.querySelector('[data-sold-out]');

      // Return early if elements don't exist
      if (!quantitySelector || !soldOutMessage) {
        return;
      }

      // Show quantity selector by default if no variant is selected
      if (!variant) {
        quantitySelector.style.display = 'block';
        soldOutMessage.style.display = 'none';
        return;
      }

      // Check if variant is available
      if (variant.available) {
        quantitySelector.style.display = 'block';
        soldOutMessage.style.display = 'none';
      } else {
        quantitySelector.style.display = 'none';
        soldOutMessage.style.display = 'block';
      }
    }

    // Initial check - show quantity selector by default
    function getCurrentVariant() {
      const variantJsonEl = document.querySelector('[data-current-variant-json]');
      if (!variantJsonEl) return null;

      try {
        return JSON.parse(variantJsonEl.textContent);
      } catch (e) {
        console.error('Failed to parse current variant JSON:', e);
        return null;
      }
    }

    const currentVariant = getCurrentVariant();
    if (currentVariant && currentVariant.available) {
      updateInventoryStatus(currentVariant);
    } else {
      const quantitySelector = document.querySelector('[data-quantity-selector]');
      const soldOutMessage = document.querySelector('[data-sold-out]');
      if (quantitySelector) quantitySelector.style.display = 'block';
      if (soldOutMessage) soldOutMessage.style.display = 'none';
    }

    // Listen for variant changes
    document.addEventListener('variant:changed', function(event) {
      const variant = event.detail.variant;
      updateInventoryStatus(variant);
    });

    // Also listen for variant selection changes
    document.querySelectorAll('.variant-input-wrap input[type="radio"]').forEach(input => {
      input.addEventListener('change', function() {
        const selectedVariant = JSON.parse(document.querySelector('[data-variant-json]').textContent)
          .find(v => v.options.every((opt, index) => opt === this.value));
        updateInventoryStatus(selectedVariant);
      });
    });

    // Check the default variant's radio buttons on page load
    function checkDefaultVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      const notifyParam = urlParams.get('notify');
      const variantParam = urlParams.get('variant');

      let variant = null;

      // When notify=1, use variant from URL - do NOT auto-select Standard
      if (notifyParam === '1' && variantParam) {
        const variantsJsonEl = document.querySelector('[data-variant-json]');
        if (variantsJsonEl) {
          try {
            const variants = JSON.parse(variantsJsonEl.textContent);
            variant = variants.find(v => String(v.id) === String(variantParam));
          } catch (e) {}
        }
      }

      if (!variant) {
        variant = currentVariant;
      }

      // Fallback: try to get from data attribute
      if (!variant) {
        const variantJsonEl = document.querySelector('[data-current-variant-json]');
        if (variantJsonEl) {
          try {
            variant = JSON.parse(variantJsonEl.textContent);
          } catch (e) {
            console.error('Failed to parse variant JSON:', e);
          }
        }
      }

      // Fallback: try to get from variants array (first available / Standard)
      if (!variant) {
        const variantsJsonEl = document.querySelector('[data-variant-json]');
        if (variantsJsonEl) {
          try {
            const variants = JSON.parse(variantsJsonEl.textContent);
            const standardVariant = variants.find(v =>
              v.available && v.options && v.options.some(option =>
                option && option.toString().toUpperCase().includes('STANDARD')
              )
            );
            // If no "Standard" variant found, fall back to first available or first variant
            variant = standardVariant || variants.find(v => v.available) || variants[0];
          } catch (e) {
            console.error('Failed to parse variants JSON:', e);
          }
        }
      }

      if (!variant) {
        console.warn('No variant found to check');
        return;
      }

      // Also update the hidden select element if it exists
      const hiddenSelect = document.querySelector('select[name="id"]');
      if (hiddenSelect && variant.id) {
        hiddenSelect.value = variant.id;
      }

      // Get all variant input fieldsets
      const fieldsets = document.querySelectorAll('.variant-input-wrap');

      if (fieldsets.length === 0) {
        console.warn('No variant fieldsets found');
        return;
      }

      fieldsets.forEach((fieldset, fieldsetIndex) => {
        const optionIndex = fieldset.getAttribute('data-index'); // e.g., 'option1'
        if (!optionIndex) return;

        // Try to get value from option1/option2/option3 properties first
        let variantOptionValue = variant[optionIndex];

        // Fallback to options array if properties don't exist
        if (!variantOptionValue && variant.options && Array.isArray(variant.options)) {
          // option1 = index 0, option2 = index 1, etc.
          const optionArrayIndex = parseInt(optionIndex.replace('option', '')) - 1;
          if (optionArrayIndex >= 0 && optionArrayIndex < variant.options.length) {
            variantOptionValue = variant.options[optionArrayIndex];
          }
        }

        if (!variantOptionValue) {
          console.warn('No option value found for', optionIndex, 'in variant:', variant);
          return;
        }

        variantOptionValue = String(variantOptionValue).trim();

        // Get all radio inputs in this fieldset
        const radioInputs = fieldset.querySelectorAll('input[type="radio"]');

        if (radioInputs.length === 0) {
          console.warn('No radio inputs found in fieldset', optionIndex);
          return;
        }

        let foundMatch = false;
        radioInputs.forEach(radioInput => {
          const radioValue = String(radioInput.value).trim();

          // Match values case-insensitively
          if (radioValue.toUpperCase() === variantOptionValue.toUpperCase()) {
            foundMatch = true;
            // Only check if not already checked to avoid unnecessary events
            if (!radioInput.checked) {
              radioInput.checked = true;
              // Trigger change event to update styling and any listeners
              const changeEvent = new Event('change', { bubbles: true });
              radioInput.dispatchEvent(changeEvent);
            }
          } else if (radioInput.checked) {
            // Uncheck other radios in the same group
            radioInput.checked = false;
          }
        });

        if (!foundMatch) {
          console.warn('No matching radio found for value:', variantOptionValue, 'in fieldset:', optionIndex);
        }
      });
    }

    // Track if we've already set the default variant
    let defaultVariantSet = false;

    // Only set default variant on initial load, not on user changes
    function setDefaultVariantOnce() {
      if (defaultVariantSet) return;

      // Check if any radio is already checked (user may have selected something)
      const hasCheckedRadio = document.querySelector('.variant-input-wrap input[type="radio"]:checked');
      if (hasCheckedRadio) {
        defaultVariantSet = true; // User has already selected, don't override
        return;
      }

      checkDefaultVariant();
      defaultVariantSet = true;
    }

    // Run multiple times to ensure it works even if Variants class interferes
    setDefaultVariantOnce();
    setTimeout(setDefaultVariantOnce, 50);
    setTimeout(setDefaultVariantOnce, 200);
    setTimeout(setDefaultVariantOnce, 500);
  });
